module.exports = __webpack_public_path__ + "img/bcaires.a57e4c7c.png";